// src/pages/GooglyHome.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const GooglyHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Digital Income");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/googly");
  };

  const groupNames = [
    { label: "Digital Income", emoji: "💸" },      
    { label: "Cricket Gyan", emoji: "🏏💡" },     
    { label: "My Cricket", emoji: "👤🏏" },   
    { label: "Playground", emoji: "🏟️" },         
    { label: "Community", emoji: "👤🏏" },   
    { label: "Marketplace", emoji: "🛒" },   
    { label: "Self Reflection", emoji: "🪞" },
    { label: "Fan Zone", emoji: "🎉🏏" },           
  ];

  // { label: "Self Reflection", emoji: "🪞" },
  // { label: "Googly Player", emoji: "🏅" },
  // { label: "Analytics & Insights", emoji: "📊" },
  // { label: "Wishes & Fun", emoji: "🎬" },

  const menuButtons1 = [
    // 💰 DIGITAL INCOME
    { label: "ValueShare", emoji: "💸", link: "/orderflow-earning-estimator", group: "Digital Income" },
    { label: "Kharcho Jeeto", emoji: "🎯💰", link: "/kharchojeeto", group: "Digital Income" },
    { label: "Rewarding Ads", emoji: "🎬💎", link: "/visigift-home", group: "Digital Income" },
    { label: "Rewarding Videos", emoji: "📺💰", link: "/orderflow-spotbuy", group: "Digital Income" },

    // 💡 CRICKET GYAN
    { label: "Immersive Learnings", emoji: "🏏📚", link: "/bookshelf", group: "Cricket Gyan" },
    { label: "Monthly Digital Book", emoji: "📖✨", link: "/googly-bookworld", group: "Cricket Gyan" },
    { label: "Cricket Shorts", emoji: "🎥⚡", link: "/litenshort", group: "Cricket Gyan" },

    // 🏏 MY CRICKET
    { label: "My Match", emoji: "🏏🗓️", link: "", group: "My Cricket" },
    { label: "My Performance", emoji: "📈🏆", link: "", group: "My Cricket" },
    { label: "My Cricket Chronicles", emoji: "📰🏏", link: "/googly-daily", group: "My Cricket" },
    { label: "My Cricket Diary", emoji: "📔🖊️", link: "/mydiary-home", group: "My Cricket" },
    { label: "My DeepThinking", emoji: "🧠💭", link: "/fivewhys-analysis-home", group: "My Cricket" },
    { label: "Goal Board", emoji: "🎯📋", link: "/googly-goalboard", group: "My Cricket" },
    { label: "Kanban", emoji: "🧩📊", link: "/googly-kanban", group: "My Cricket" },

    // 🏟️ PLAYGROUND
    { label: "International", emoji: "🌍🏏", link: "", group: "Playground" },
    { label: "Food", emoji: "🍱🥤", link: "/bhojan", group: "Playground" },
    { label: "Events", emoji: "🎪📢", link: "/event-flow-home", group: "Playground" },
    { label: "Ranking", emoji: "🏅📊", link: "/googly-ranking", group: "Playground" },
    { label: "Your Stats", emoji: "📊🏏", link: "", group: "Playground" },
    { label: "Leaderboards", emoji: "🥇🏏", link: "", group: "Playground" },
    { label: "Point Tables", emoji: "📋🏏", link: "", group: "Playground" },
    { label: "Looking", emoji: "🔍🏏", link: "", group: "Playground" },
    { label: "Add Tournament", emoji: "➕🏆", link: "", group: "Playground" },
    { label: "Go Live", emoji: "🔴📡", link: "", group: "Playground" },
    { label: "Player Leaderboard", emoji: "👤🥇", link: "", group: "Playground" },
    { label: "Team Leaderboard", emoji: "👥🥇", link: "", group: "Playground" },
    { label: "Awards", emoji: "🏆🎉", link: "", group: "Playground" },
    { label: "Associations", emoji: "🤝🏏", link: "", group: "Playground" },
    { label: "Clubs", emoji: "🏏🏠", link: "", group: "Playground" },
    { label: "View Match", emoji: "👀🏏", link: "", group: "Playground" },

    // 👥 COMMUNITY
    { label: "Scores", emoji: "📈🏏", link: "", group: "Community" },
    { label: "Umpires", emoji: "🧑‍⚖️🏏", link: "", group: "Community" },
    { label: "Commentators", emoji: "🎙️🏏", link: "", group: "Community" },
    { label: "Streamers", emoji: "📺🎥", link: "", group: "Community" },
    { label: "Organisers", emoji: "🗂️🏟️", link: "", group: "Community" },
    { label: "Academics", emoji: "🎓🏏", link: "", group: "Community" },
    { label: "Grounds", emoji: "🏟️🌿", link: "", group: "Community" },
    { label: "Physio & Fitness", emoji: "💪🧘", link: "", group: "Community" },
    { label: "Personal Coaching", emoji: "🧑‍🏫🏏", link: "", group: "Community" },
    { label: "Box Cricket", emoji: "📦🏏", link: "", group: "Community" },
    { label: "Shops", emoji: "🏪🏏", link: "", group: "Community" },

    // 🛍️ MARKETPLACE
    { label: "Cricket Kart", emoji: "🛒🏏", link: "/orderflow-home", group: "Marketplace" },
    { label: "CricRoom", emoji: "🏠🏏", link: "/roomanywhere", group: "Marketplace" },
    { label: "Clap4Service", emoji: "👏🤝", link: "/clap4service", group: "Marketplace" },

    // 🪞 SELF REFLECTION
    { label: "My Player Card", emoji: "💖🏏", link: "", group: "Self Reflection" },
    { label: "My Memories", emoji: "🕰️📸", link: "/memories-list", group: "Self Reflection" },
    { label: "Focus Timer", emoji: "⏱️🧘", link: "/googly-focustimerstart", group: "Self Reflection" },
    { label: "IKIGAI", emoji: "🌸✨", link: "/myprofile-ikigai", group: "Self Reflection" },
    { label: "Googly AI Counselling", emoji: "🤖🧠", link: "/aicounselling", group: "Self Reflection" },
    { label: "Self Applause", emoji: "👏🌟", link: "/self-applause", group: "Self Reflection" },
    { label: "I Was Appreciated", emoji: "💬👏", link: "/applause-for-me", group: "Self Reflection" },

    // 🎉 FAN ZONE
    { label: "Applause", emoji: "👏🏏", link: "/applause-hub-home", group: "Fan Zone" },
    { label: "Green Googly", emoji: "🌱🏏", link: "/coolearth-home", group: "Fan Zone" },
    { label: "Cricket Presentation", emoji: "📊🏏", link: "/visualbrief-home", group: "Fan Zone" },
    { label: "Cricket Forum", emoji: "💬🗣️", link: "/povify-home", group: "Fan Zone" },
    { label: "crickTube", emoji: "▶️📺", link: "/cricktube", group: "Fan Zone" },
    { label: "Googly Games", emoji: "🎮🏏", link: "/googly-games", group: "Fan Zone" },
  ];  

  const filteredButtons = menuButtons1.filter((btn) => btn.group === activeTab);

  return (
    <div className="min-h-screen flex flex-col bg-[#1a0b1e] text-green-100 font-sans">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#2a0f2f] border-b border-green-800 px-4 py-2 flex items-center justify-between shadow-lg">
        <div className="flex flex-col">
          <div className="text-xl lg:text-2xl font-bold text-green-400">🏏 Googly</div>
          <div className="text-[10px] lg:text-lg text-yellow-200">
            Your Cricket Passion Pays! Digital Earning for Cricket Loving People! 
          </div>
        </div>

        {/* Desktop user controls */}
        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-sm text-green-300">👋 {userName}</div>
              <button
                onClick={handleLogout}
                className="p-2 rounded-md bg-rose-600 hover:bg-rose-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-3 py-1 rounded-full border border-green-700 text-sm text-green-200 hover:bg-green-900"
              >
                Login
              </button>
              <button
                onClick={() => navigate("/signup")}
                className="px-3 py-1 rounded-full bg-green-500 text-white text-sm hover:bg-green-400"
              >
                Register
              </button>
            </>
          )}
        </div>

        {/* Mobile hamburger */}
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-6 h-6 flex items-center justify-center text-xl text-green-300 bg-green-500"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {/* Mobile menu content */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-[#2a0f2f] border-b border-green-800 px-4 py-2 animate-fadeIn">
          {isLoggedIn ? (
            <div className="flex flex-row items-center justify-center gap-3">
              <span className="text-green-300 font-medium whitespace-nowrap h-7">
                Welcome, {userName}
              </span>
              <button
                onClick={handleLogout}
                className="rounded-md bg-rose-600 hover:bg-rose-700 w-7 h-7 flex items-center justify-center text-white"
                title="Logout"
              >
                ⏻
              </button>
            </div>
          ) : (
            <div className="flex flex-row items-center justify-center gap-6">
              <Link to="/login" className="text-green-300 hover:text-yellow-300">
                Login
              </Link>
              <span className="text-green-500">|</span>
              <Link to="/signup" className="text-green-300 hover:text-yellow-300">
                Register
              </Link>
            </div>
          )}
        </div>
      )}

      {/* Top quick links */}
      <div className="bg-green-900/40 text-white text-xs sm:text-sm py-2 mt-2">
        <div className="max-w-6xl mx-auto px-3 flex flex-wrap justify-center gap-2 text-m lg:text-lg">
          <a href="/googly-insights" className="hover:text-yellow-200">💭 About</a>
          <Link to="/litenshort" className="hover:text-yellow-200">🗞️ Short News</Link>
          <a href="/googly-updates" className="hover:text-yellow-200">📊 Updates</a>
          <a href="/googly-faq" className="hover:text-yellow-200">🤔 FAQ</a>
        </div>
        {/* <div className="text-[12px] lg:text-lg text-center my-1 mx-1 mt-2  text-green-200/90">
           Extending Digital Empowerment for Cricket Loving People!
        </div> */}
        {/* <div className="mt-3 flex flex-wrap justify-center gap-3 text-sm text-blue-500">
          <Link to="/think5whysistrusted" className="text-yellow-200 hover:text-yellow-300 text-[12px] lg:text-lg">
            🔒 Trusted & Secure Platform – ISO 9001, ISO 27001, SOC-2 Certified
          </Link>        
        </div> */}
      </div>

      {/* Tabs */}
      <div className="mt-1 mb-1 px-3 py-2 border-b border-green-700">
        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-5 gap-0 place-items-center">
          {groupNames.map((group) => (
            <button
              key={group.label}
              onClick={() => setActiveTab(group.label)}
              className={`flex flex-col items-center justify-center w-full px-2 py-2 rounded-md text-xs sm:text-sm font-medium transition ${
                activeTab === group.label
                  ? "bg-green-600 text-yellow-200 shadow-md"
                  : "bg-green-800 text-green-100 hover:bg-green-900"
              }`}
            >
              <span className="text-xl">{group.emoji}</span>
              <span className="mt-1 text-m text-center">{group.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Main grid */}
      <main className="flex-grow mx-auto px-3 py-2 w-full justify-center items-center text-center">
        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-5 gap-0 place-items-center">
          {filteredButtons.length === 0 ? (
            <div className="col-span-3 sm:col-span-3 md:col-span-5 text-center text-green-400">
              No items in this category.
            </div>
          ) : (
            filteredButtons.map((btn, idx) => (
              <button
                key={`${btn.label}-${idx}`}
                onClick={() => navigate(btn.link)}
                className="flex flex-col items-center justify-center w-full px-1.5 py-1 rounded-md text-[14px] sm:text-m font-medium transition bg-transparent hover:bg-green-700 hover:text-yellow-200 text-green-100 break-words text-center shadow-sm"
                title={btn.label}
              >
                <span className="text-xl lg:text-lg">{btn.emoji}</span>
                <span className="mt-1">{btn.label}</span>
              </button>
            ))
          )}
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#2a0f2f] border-t border-green-800 text-green-300 py-4">
        <div className="max-w-6xl mx-auto px-3 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs lg:text-sm">
            © 2025 Think5Whys Global DeepTech Solutions. All rights reserved.
          </div>
          <div className="flex flex-wrap gap-4 text-xs lg:text-sm">
            <Link to="/about-us" className="text-white hover:text-green-400">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-green-400">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-green-400">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-green-400">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );

};

export default GooglyHome;
